import { render, staticRenderFns } from "./TransferenciasPublicasTable.vue?vue&type=template&id=12a1c05e&scoped=true"
import script from "./TransferenciasPublicasTable.vue?vue&type=script&lang=ts"
export * from "./TransferenciasPublicasTable.vue?vue&type=script&lang=ts"
import style0 from "./TransferenciasPublicasTable.vue?vue&type=style&index=0&id=12a1c05e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a1c05e",
  null
  
)

export default component.exports